import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    error: undefined,
    menuInfo: undefined,
};

const menuSlice = createSlice({
    name: 'menu',
    initialState,
    reducers: {
        setMenuLoading: (state, action) => {
            state.loading = action.payload;
        },
        setMenuError: (state, action) => {
            state.error = action.payload;
        },
        setMenuInfo: (state, action) => {
            const { payload } = action;
            state.menuInfo = payload;
        },
        clearMenuState: (state) => {
            state.loading = false;
            state.error = undefined;
            state.menuInfo = undefined;
        },
    },
});

export const { setMenuLoading, setMenuError, setMenuInfo, clearMenuState } = menuSlice.actions;

export default menuSlice.reducer;